<template>
  <v-expansion-panel-content class="device-details-wrapper">
    <div class="device-details-content">
      <div class="device-details-content-item-wrapper">
        <div class="device-details-content-item">
          <div class="col-wrapper">
            <DeviceBloc :device="props.device" />
            <VehicleBloc
              v-if="vehiclePerso"
              :device="props.device"
              @seeMore="goToPerso"
            />
          </div>
          <LastPosition v-if="props.mapDataLoaded && getCurrentUserIsAbleTo('read', 'vehicleTrackingRecord')" :lastPosition="props.position" @trackingRecords="overlay = true" />
          <HistoryBloc v-if="getCurrentUserIsAbleTo('read', 'history')" :device="props.device" />
          <TrackingRecords :device="props.device" :overlay="overlay" @close="overlay = false" />
        </div>
      </div>
    </div>
  </v-expansion-panel-content>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import useStore from '@/utils/store/common';
import { useRouter } from 'vue-router/composables';
import { V2Device } from 'ctp-search-device';
import TrackingRecords from '@/components/common/TrackingRecords/TrackingRecords.vue';
import DeviceBloc from './components/DeviceBloc/DeviceBloc.vue';
import VehicleBloc from './components/VehicleBloc/VehicleBloc.vue';
import LastPosition from './components/LastPosition/LastPosition.vue';
import HistoryBloc from './components/HistoryBloc/HistoryBloc.vue';

const props = defineProps({
  device: {
    type: Object,
    default: () => ({} as V2Device)
  },
  mapDataLoaded: {
    type: Boolean,
    default: false
  },
  position: {
    type: Object,
    default: () => ({})
  }
});

const store = useStore();
const router = useRouter();

const getCurrentUserIsAbleTo = computed(() => store.getters['permissions/getCurrentUserIsAbleTo']);

const overlay = ref(false);

const vehiclePerso = computed(() => {
  if (props.device.devicePersonalisationState && props.device.devicePersonalisationState.inProgress) {
    return props.device.devicePersonalisationState.targetPersonalisation?.vehicleInfo;
  }
  return props.device.devicePersonalisationState?.currentPersonalisation?.vehicleInfo;
});

function goToPerso() {
  let id = props.device.shortDeviceId;
  if (props.device.type === 'vdolink') {
    id = props.device.pairingInfo?.dtcoId;
  }
  router.push({
    name: 'personalisation',
    params: {
      deviceId: id || ''
    }
  });
}
</script>
<style lang="scss" scoped>
@import './styles/device-details.scss';
</style>
